// 1. select forms with 'lazy load' class
// 2. in markup, disable submit button
// 3. on any form interaction, load in the recaptcha
// 4. fire off the init recaptcha script to set the value on the captcha input
// 5. remove the disabled action

let isLoaded = false

const load = () => {
    isLoaded = true

    return new Promise((res) => {
        const recaptcha = document.createElement('script')
        recaptcha.src = 'https://www.google.com/recaptcha/api.js?render=6Lc-rMQUAAAAADV2mKipU4L1CXVg1JnmqH1R6Hg2'
        recaptcha.async = true
        recaptcha.onload = res
        document.querySelector('body').appendChild(recaptcha)
    })
}

const removeDisabledFromSubmit = (form) => {
    const button = form.querySelector('button[type=submit]')
    button.disabled = false
}

$(document).ready(function () {
    const forms = document.querySelectorAll('.js_lazyRecaptchaForm')
    forms.forEach((f) => {
        f.addEventListener('input', async () => {
            if (isLoaded) {
                return
            }

            try {
                await load()
            } catch (e) {
                console.error(e)
            } finally {
                grecaptcha.ready(() => {
                    recaptchaInitV3();
                    forms.forEach((f) => removeDisabledFromSubmit(f))
                });
            }
        })
    })
})